import { queryOptions, useQuery } from '@tanstack/react-query';

import { auctionsApi } from '../api/auctions-api';

import { auctionKeys } from './auction-keys';

export function auctionOffersQueryOptions(storeId: string, auctionId: string) {
  return queryOptions({
    queryKey: auctionKeys.offers(storeId, auctionId),
    queryFn: () => auctionsApi.offers(storeId, auctionId),
  });
}

/** Second-chance offers only exist once bidding closed, so the query waits for an ended auction. */
export function useAuctionOffers(storeId: string, auctionId: string, enabled: boolean) {
  return useQuery({ ...auctionOffersQueryOptions(storeId, auctionId), enabled });
}
